import qs from 'qs';

import { removeEmptyValues } from 'dpl/shared/utils/object';
import { ANALYTICS, REFERRER, SEARCH_PARAMS } from 'dpl/constants/query_params';
import { isMobileUA } from 'dpl/shared/utils';

const IS_MOBILE = isMobileUA();

export function openPuppyPage(
  { puppyId, locName, gender, analytics, searchParams, referrer },
  target
) {
  const queryStr = qs.stringify(
    removeEmptyValues({
      [ANALYTICS]: analytics,
      [SEARCH_PARAMS]: searchParams,
      [REFERRER]: referrer,
      locName,
      gender
    })
  );

  const pageUrl = [`/puppy/${puppyId}`, queryStr].filter(Boolean).join('?');

  window.open(pageUrl, target || (IS_MOBILE ? '_self' : '_blank'));
}
